import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useRef, useState, useCallback } from 'react';
import { Manager, Reference } from 'react-popper';
import './Menu.scss.js';
import List from './List/List.js';
import { classnames } from '../../../utils/classnames.js';
import Popper from '../Popper/Popper.js';

/** Контекст для передачи функций работы с меню. */

var MenuContext = /*#__PURE__*/React__default.createContext({
  onClose: function onClose() {},
  show: false
});

var Menu = function Menu(_a) {
  var list = _a.list,
      children = _a.children,
      content = _a.content,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$toggleTagret = _a.toggleTagret,
      toggleTagret = _a$toggleTagret === void 0 ? true : _a$toggleTagret,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'm' : _a$size,
      props = __rest(_a, ["list", "children", "content", "className", "toggleTagret", "disabled", "size"]);

  var toggleRef = useRef(null);
  /** Флаг отображения выпадающего списка  */

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];
  /** Изменение состояния выпадающего списка */


  var onToggle = useCallback(function () {
    setShow(function (show) {
      return !show;
    });
  }, [setShow]);
  var onClose = useCallback(function () {
    setShow(false);
  }, [setShow]);
  /** Клик по кнопке */

  var onClick = useCallback(function (e) {
    e.preventDefault();

    if (disabled) {
      return;
    }

    if (toggleTagret) {
      onToggle();
    } else {
      setShow(true);
    }
  }, [onToggle, disabled, toggleTagret]);
  return /*#__PURE__*/React__default.createElement(MenuContext.Provider, {
    value: {
      onClose: onClose,
      show: show
    }
  }, /*#__PURE__*/React__default.createElement(Manager, {
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-menu', className),
    "data-testid": "rf-menu",
    ref: toggleRef,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Reference, {
    "data-v-6e52f9c7": ""
  }, function (referenceProps) {
    return /*#__PURE__*/React__default.createElement("div", _extends({}, referenceProps, {
      className: "rf-menu__toggle",
      onClick: onClick,
      "data-v-6e52f9c7": ""
    }), children);
  }), /*#__PURE__*/React__default.createElement(Popper, _extends({}, props, {
    show: show,
    toggleRef: toggleRef,
    onClose: onClose,
    "data-v-6e52f9c7": ""
  }), content ? content : list && list.length > 0 && /*#__PURE__*/React__default.createElement(List, {
    list: list,
    size: size,
    "data-v-6e52f9c7": ""
  })))));
};

export { MenuContext, Menu as default };
